window.addEventListener("load", () => {
  
  // 1. Функція для автоматичного розмноження слайдів (щоб Swiper міг зробити Loop)
  function autoCloneSlides(wrapperSelector, minRequired = 12) {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) return;
    
    const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
    // Якщо слайдів вже багато, або їх взагалі немає - нічого не робимо
    if (slides.length === 0 || slides.length >= minRequired) return;

    // Дублюємо наявні слайди, поки їх загальна кількість не стане достатньою
    let currentCount = slides.length;
    while (currentCount < minRequired) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        wrapper.appendChild(clone);
        currentCount++;
      });
    }
  }

  // 2. Клонуємо контент ДО запуску Swiper (передаємо клас врапера і мінімальну кількість)
  // Якщо у вас 3 тексти, функція зробить з них 12, і Swiper буде щасливий
  autoCloneSlides(".swiper-wrapper-1", 12);
  autoCloneSlides(".swiper-wrapper-2", 12);
  autoCloneSlides(".swiper-wrapper-0", 12); // Для зображень теж про всяк випадок

  // 3. Базові налаштування для безперервного руху
  const marqueeBase = {
    loop: true,
    allowTouchMove: false, // Вимикаємо ручне перетягування для стабільності
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    on: {
      init: function (swiperInstance) {
        setTimeout(() => {
          swiperInstance.autoplay.start();
        }, 100);
      }
    }
  };

  // 4. Ініціалізація
  if (document.querySelector(".swiper-container-0")) {
    new Swiper(".swiper-container-0", {
      ...marqueeBase,
      wrapperClass: "swiper-wrapper-0",
      spaceBetween: 24,
      speed: 5000,
      slidesPerView: "auto",
    });
  }

  if (document.querySelector(".swiper-container-text-1")) {
    new Swiper(".swiper-container-text-1", {
      ...marqueeBase,
      wrapperClass: "swiper-wrapper-1",
      speed: 10000,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 100, 
    });
  }

  if (document.querySelector(".swiper-container-text-2")) {
    new Swiper(".swiper-container-text-2", {
      ...marqueeBase,
      wrapperClass: "swiper-wrapper-2",
      speed: 10000,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 100,
    });
  }
});